import { IApplicationState } from '../../../types/redux';

/**
 * Авторизован ли пользователь
 */
export const isUserAuthenticatedSelect = ({ userNew }: IApplicationState) => {
  return userNew.isAuthenticated;
};
